import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { safe } from 'ini';
import { io } from 'socket.io-client';


export const pagesSlice = createSlice({
    name: 'pages',
    initialState: {
        selectedFeatureId: undefined,
        currentStep: 0,
        pages: {
            hardware: {
                tutorial: localStorage.getItem('cody_tutorial_hardware'),
            },
            features: {
                tutorial: localStorage.getItem('cody_tutorial_features'),
            },
            appblocks: {
                tutorial: localStorage.getItem('cody_tutorial_appblocks'),
                viewport: {
                    main: {
                        x: 0,
                        y: 0,
                        zoom: 1,
                    },
                },
                connection: {
                    nonConnectable: {},
                },
                groupTab: '',
                selectedFeature: undefined,
            },
        },
        showDeviceExplorer: false,
        showBottomPanel: false,
        projectEditable: false,
        showErrors: false,
        showConfig: false,
        showCode: {
            show: false,
            file: undefined,
            line: 0,
        },
        editedFeatures: [],
        editedSettingTab: null,
    },
    reducers: {
        setPageFeature: (state, action) => {
            return {
                ...state,
                pages: {
                    ...state.pages,
                    [action.payload.page]: {
                        ...state.pages[action.payload.page],
                        selectedFeature: action.payload.selectedFeature,
                        shouldCenter: action.payload.shouldCenter,
                    },
                },
                editedFeatures: action.payload.editedFeatures || [...state.editedFeatures],
            };
        },
        setPanelPreference: (state, action) => {
            state.panels = {
                ...state.panels,
                [action.payload.name]: action.payload.value,
            };
        },
        setPageProperty: (state, action) => {
            return {
                ...state,
                pages: {
                    ...state.pages,
                    [action.payload.page]: {
                        ...state.pages[action.payload.page],
                        [action.payload.property]: action.payload.value,
                    },
                },
            };
        },
        setShowDeviceExplorer: (state, action) => {
            state.showDeviceExplorer = action.payload;
        },
        setShowBottomPanel: (state, action) => {
            state.showBottomPanel = action.payload;
        },
        setProjectEditable: (state, action) => {
            state.projectEditable = action.payload;
        },
        setShowCode: (state, action) => {
            state.showCode = action.payload;
        },
        setEditedFeatures: (state, action) => {
            const { editedFeatures } = state;
            if (action.payload) {
                editedFeatures.push(action.payload);
            }
            state.editedFeatures = [...editedFeatures];
        },
        popEditedFeatures: (state, action) => {
            const { editedFeatures } = state;
            editedFeatures.pop();
            state.editedFeatures = [...editedFeatures];
        },
        setCurrentStep: (state, action) => {
            state.currentStep = action.payload;
        },
        setShowErrors: (state, action) => {
            state.showErrors = action.payload;
        },
        setSelectedFeature: (state, action) => {

        },
        setConnection: (state, action) => {
            state.pages.appblocks.connection = {
                source: action.payload.source,
                sourceHandle: action.payload.sourceHandle,
                target: action.payload.target,
                targetHandle: action.payload.targetHandle,
                nonConnectable: action.payload.nonConnectable,
            };
        },
        setEditedSettingTab: (state, action) => {
            state.editedSettingTab = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const {
    setPageFeature,
    setPageProperty,
    setPanelPreference,
    setShowDeviceExplorer,
    setShowBottomPanel,
    setEditedFeatures,
    popEditedFeatures,
    setCurrentStep,
    setShowErrors,
    setSelectedFeature,
} = pagesSlice.actions;

export default pagesSlice.reducer;
